import { mapState as rootMapState } from 'pinia';
import { usePageStore } from "@/store";
import { mapState } from '@/store/helpers';
import noDisclosure from '@/components/nodisclosure';
import { getTrend } from '@/common/house'

import TaxStatus from "@/common/customs/TaxStatus";

export default {
    components: { noDisclosure, TaxStatus },
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page || {},
            currencySymbol: store => store.currency.symbol
        }),
        ...mapState({
            info: store => store.listingDetail.info || {}
        }),
        showListingPrice({ page }) {
            return page.house?.showListingPrice;
        },
        cmpNondisclosureDes() {
            return (
                this.nodisclosureDes ?? this.$t('md-sold-detail:nondisclosure')
            );
        },
        trend() {
            let { soldPrice, price } = this.info;
            return getTrend(soldPrice, price).trend;
        },
    },
    inject: ['showSoldPrice']
};